import { Icon } from '@chakra-ui/react';

export const CustomCreditCardMultiIcon = (props) => (
  <Icon
    viewBox="0 0 27 27"
    width="30px"
    height="30px"
    fill="none"
    className="sideNavIcon"
    {...props}
  >
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M21.5156 5.0625H5.48438C3.85341 5.0625 2.53125 6.38466 2.53125 8.01562V18.9844C2.53125 20.6153 3.85341 21.9375 5.48438 21.9375H21.5156C23.1466 21.9375 24.4688 20.6153 24.4688 18.9844V8.01562C24.4688 6.38466 23.1466 5.0625 21.5156 5.0625Z"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M2.53125 10.125H24.4688M6.75 15.8203H9.28125V16.875H6.75V15.8203Z"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.875"
      strokeLinejoin="round"
    />
  </Icon>
);
